var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreatmentFilled = function SvgTreatmentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5943_3361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9 31.4044V27.2736C19.6328 27.2736 19.5536 26.7973 22.9688 24.0968C27.3372 24.0968 27.8932 17.9812 27.8932 14.7248C27.8932 11.4684 27.0989 1.46094 15.9 1.46094C6.94081 1.46094 4.22456 8.55621 3.98633 12.1038V19.9669C3.98633 28.926 11.9288 31.3249 15.9 31.4044Z",
    fill: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5399 9.93334C12.5399 11.5236 9.64665 13.0184 8.20004 13.1159L8.19995 19.7284C8.19995 23.9973 11.7406 27.458 16.1081 27.458C20.4757 27.458 24.0163 23.9973 24.0163 19.7284L24.0164 15.0079C20.1909 14.8903 11.8379 12.8825 11.8379 6.65332",
    stroke: "#2698EB",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6258 24.3293C28.1167 23.7394 28.1167 15.0196 28.1167 13.428C28.1167 6.7961 22.7405 1.41992 16.1086 1.41992C9.47677 1.41992 4.10059 6.7961 4.10059 13.428C4.10059 15.0196 4.10059 10.1949 4.10059 19.9364C4.10059 29.6778 13.6455 31.4199 16.1086 31.4199L16.1086 27.9923",
    stroke: "#2698EB",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.478 22.5791C14.0492 23.3184 15.014 23.8041 16.1079 23.8041C17.2019 23.8041 18.1667 23.3184 18.7378 22.5791",
    stroke: "#2698EB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5943_3361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0515137 0.419922)"
  })))));
};
export default SvgTreatmentFilled;